import { useAppDispatch, useAppSelector } from '../state/hooks'
import { resetCartPrepState } from '../state/Slices/persistedSlice'
import { useToggleConfirmModal } from './useToggleConfirmModal'
import { useEmptyCart } from './useEmptyCart'
export const useInitializeOrder = () => {
	const dispatch = useAppDispatch()
	const { localTimezone } = useAppSelector(state => state.settings)

	const toggleConfirmModal = useToggleConfirmModal()
	const emptyCart = useEmptyCart()
	return () => {
		toggleConfirmModal()
		dispatch(resetCartPrepState({ localTimezone: localTimezone, getLongestPrepTime: 15 }))
		emptyCart()
	}
}
